import React from 'react';
import classNames from 'classnames';

const WORST_SCORE = 1500;
const PENALTIES = { HTTPS: 200, VALID_HTTPS: 200, HTTP2: 200, DOWNLOAD: 50, TTFB: 10 };

const penalty = (stats) => {
  const diff_from_nf = stats.complete_load.value - stats.netlify_estimate;
  const ttfb_diff_from_nf = stats.first_byte.value - 8;

  let penalty = 0;
  if (diff_from_nf > 0) {
    penalty += (stats.complete_load.value - stats.netlify_estimate) * PENALTIES.DOWNLOAD;
  }
  if (ttfb_diff_from_nf > 0) {
    penalty += (stats.first_byte.value / 8) * PENALTIES.TTFB;
  }
  if (!stats.is_https.value) {
    penalty += PENALTIES.HTTPS;
  }
  if (!stats.is_http_2.value) {
    penalty += PENALTIES.HTTP2;
  }
  return Math.min(penalty, WORST_SCORE);
};

const transformStyle = (degs) => {
  return {
    WebkitTransform: 'rotate(' + degs + 'deg)',
    msTransform: 'rotate(' + degs + 'deg)',
    transform: 'rotate(' + degs + 'deg)',
    transition: 'transform ' + 1.33 + 's'
  };
};

class Score extends React.Component {
  render() {
    const score = this.props.isBroken ? 0 : Math.ceil((WORST_SCORE - penalty(this.props.stats)) / WORST_SCORE * 100);
    const className = classNames(
      'results__score',
      {'is-with-score': score > 0},
      {'is-good': score >= 66},
      {'is-regular': score >= 33 && score < 66},
      {'is-bad': score < 33},
      {'is-condenced': this.props.condenced}
    );
    const degs = Math.round(score*180/100);
    return (
      <div className={className}>
        <div className="results__score__mask is-ahead" style={transformStyle(degs)}>
          <div className="results__score__fill" style={transformStyle(degs)}></div>
        </div>
        <div className="results__score__mask">
          <div className="results__score__fill" style={transformStyle(degs)}></div>
          <div className="results__score__fill is-fix" style={transformStyle(degs*2)}></div>
        </div>
        <div className="results__score__marker"></div>
        <div className="results__score__marker is-end" style={transformStyle(degs*2)}></div>
        <div className="results__score__content">
          {!this.props.condenced && <div className="is-label">You scored</div>}
          <div className="is-value">{score}/100</div>
        </div>
      </div>
    );
  }
}

Score.propTypes = {
  stats: React.PropTypes.object,
  status: React.PropTypes.number
};

export default Score;



// WEBPACK FOOTER //
// ./src/components/results/Score.js